import { config } from "../config/config";
export const buildWeatherApiUrl = (url, options = {
    lang: "fr",
    limit: 40,
}) => {
    var _a;
    const apiUrl = config.REACT_APP_WEATHER_API_BASE_URL;
    const apiKey = config.REACT_APP_WEATHER_API_KEY;
    return `${apiUrl}${url}&appid=${apiKey}&lang=${(_a = options.lang) !== null && _a !== void 0 ? _a : "fr"}&units=metric&limit=${options.limit}`;
};
export const getWeatherCitiesUrl = (city) => {
    return buildWeatherApiUrl(`/geo/1.0/direct?q=${city}`, {
        limit: 5,
    });
};
export const getCurrentWeatherUrl = ({ lat, lon, }) => {
    return buildWeatherApiUrl(`/data/2.5/weather?lat=${lat}&lon=${lon}`);
};
export const getForecastWeatherUrl = ({ lat, lon, limit, }) => {
    return buildWeatherApiUrl(`/data/2.5/forecast?lat=${lat}&lon=${lon}`, {
        limit,
    });
};
export const weatherFetchUrl = ({ selectedCity, weatherType, }) => {
    return selectedCity
        ? weatherType === "current"
            ? getCurrentWeatherUrl({
                lat: selectedCity.lat,
                lon: selectedCity.lon,
            })
            : weatherType === "hourly"
                ? getForecastWeatherUrl({
                    lat: selectedCity.lat,
                    lon: selectedCity.lon,
                    limit: 6,
                })
                : getForecastWeatherUrl({
                    lat: selectedCity.lat,
                    lon: selectedCity.lon,
                    limit: 40,
                })
        : null;
};
